'use strict';

/* Imports */
import 'ng-image-gallery/dist/ng-image-gallery';
import 'ng-image-gallery/dist/ng-image-gallery.css';

/* Views */
import GalleryEdit from './edit/gallery-edit.component';
import GalleryList from './list/gallery-list.component';
import GalleryView from './show/gallery-show.component';

/* Services */
import GalleryService from '../../services/gallery/gallery.service';

export default angular.module('conduuApp.gallery', [GalleryEdit, GalleryList, GalleryView, GalleryService, 'thatisuday.ng-image-gallery'])
  .name;



// WEBPACK FOOTER //
// ./client/app/gallery/index.js